module.exports = __webpack_public_path__ + "img/Sycamore 1215x500 v2.027158da.png";